import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { LIMIT_OPERATIONS_ROUTE_PATHS } from './config';

export const LIMIT_OPERATIONS_ROUTES: TApplicationRoute[] = [
  {
    id: 'limit-operations',
    path: LIMIT_OPERATIONS_ROUTE_PATHS.limitOperations,
    component: lazy(() => import('./pages/limit-operations-page')),
    layout: 'default',
    permissions: { scopes: ['limit-operations'] },
    menu: {
      title: 'pages.fraud.limitOperations.title',
    },
  },
];
